import defaults from "./config.json";

export const algodHost = import.meta.env.VITE_ALGOD_HOST ?? defaults.algodHost;
export const algodPort = import.meta.env.VITE_ALGOD_PORT ?? defaults.algodPort;
export const algodToken =
  import.meta.env.VITE_ALGOD_TOKEN ?? defaults.algodToken;
export const indexerHost =
  import.meta.env.VITE_INDEXER_HOST ?? defaults.indexerHost;
export const indexerPort =
  import.meta.env.VITE_INDEXER_PORT ?? defaults.indexerPort;
export const indexerToken =
  import.meta.env.VITE_INDEXER_TOKEN ?? defaults.indexerToken;
export const network = import.meta.env.VITE_NETWORK ?? defaults.network;
export const dsRegistryAppId =
  import.meta.env.VITE_DS_REGISTRY_APP_ID ?? defaults.dsRegistryAppId;
export const dsSunsetRegistryAppId =
  import.meta.env.VITE_DS_SUNSET_REGISTRY_APP_ID ??
  defaults.dsSunsetRegistryAppId;
export const dsFarmAppId =
  import.meta.env.VITE_DS_FARM_APP_ID ?? defaults.dsFarmAppId;
export const tinymanAppId =
  import.meta.env.VITE_TINYMAN_APP_ID ?? defaults.tinymanAppId;
export const arc59RouterAppId =
  import.meta.env.VITE_ARC59_ROUTER ?? defaults.arc59RouterAppId;
export const sender = import.meta.env.VITE_SENDER ?? defaults.sender;
export const explorer = import.meta.env.VITE_EXPLORER ?? defaults.explorer;
export const benchRegistryAppId = import.meta.env.VITE_BENCH_REGISTRY_APP_ID
  ? BigInt(import.meta.env.VITE_BENCH_REGISTRY_APP_ID)
  : BigInt(defaults.benchRegistryAppId);
export const dsDisabled =
  import.meta.env.VITE_DS_DISABLED ?? defaults.dsDisabled;
export const defaultSender =
  import.meta.env.VITE_DEFAULT_SENDER ?? defaults.defaultSender;
export const defaultAbelAppId = import.meta.env.VITE_ABEL_APP_ID
  ? BigInt(import.meta.env.VITE_ABEL_APP_ID)
  : BigInt(defaults.abelAppId);

export default {
  algodHost,
  algodPort,
  algodToken,
  indexerHost,
  indexerPort,
  indexerToken,
  network,
  dsRegistryAppId,
  dsSunsetRegistryAppId,
  dsFarmAppId: Number(dsFarmAppId),
  tinymanAppId,
  arc59RouterAppId,
  sender,
  explorer,
  benchRegistryAppId,
  dsDisabled,
  defaultSender,
};
